import { CsvOwnerT } from '../../hooks/getCsvOwner';
import { UploadedFileT } from '../../hooks/uploadedFiles';

export function getUploadedFileMetadata(
    uploadedFile: UploadedFileT | undefined,
    data: GetDataResponse | undefined,
    owner: CsvOwnerT | undefined,
) {
    const headerMetadata = {
        rowNumber: (data && data.data && data.data.length) || 0,
        ownerEmail: (owner && owner.email) || '-',
    };
    if (!uploadedFile)
        return {
            ...headerMetadata,
            lastUpdatedDate: '-',
            lastImportedFileName: '-',
        };
    return {
        ...headerMetadata,
        lastUpdatedDate: uploadedFile && uploadedFile.uploadDate,
        lastImportedFileName: uploadedFile && uploadedFile.name,
    };
}
